export default __webpack_public_path__ + "static/media/7.9561d249.jpg";